// extracted by mini-css-extract-plugin
module.exports = {"content":"collapse_content__JoWQb","show":"collapse_show__rpnoT"};